import { fdc } from "@/helpers/fabricadecodigo"
import axios from 'axios'

export const reportabilidadService = {
    listaEstacionadores
}

function listaEstacionadores()  {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/data/estacionadores"), fdc.getHeader()).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener datos", "status": error.response.status });
        });
    })
}
